import { Notification, RemoveNotificationByKey } from './types'

export const removeItemsByKey: RemoveNotificationByKey = (
  array,
  key,
  value,
): Notification[] => {
  return array.filter(item => !(item[key] === value))
}
